import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../../../assets/icons";

interface MenuItemProps {
  to: any;
  label: any;
  icon: any;
}

const MenuItem: React.FC<MenuItemProps> = ({ to, label, icon }) => {
  const location = useLocation();
  const active = location.pathname === to;
  const isSettings = to === "/settings";
  const [backgroundBlue, setBackgroundBlue] = useState(false);

  const handleMouseEnter = () => {
    setBackgroundBlue(true);
  };

  const handleMouseLeave = () => {
    setBackgroundBlue(false);
  };

  return (
    <Link to={to}>
      <div
        className={`flex gap-3 items-center mb-4 p-2 rounded-md font-semibold fill-base cursor-pointer text-sm
          ${active ? "bg-[#0979A1CC] text-[#fff]" : "hover:bg-gray-100"}
          ${isSettings ? "mt-20" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        <Icon
          name={icon}
          className={backgroundBlue ? "fill-white" : "fill-white"}
        />
        {label}
      </div>
    </Link>
  );
};

const Menu: React.FC = () => {
  const user = useMemo(
    () => JSON.parse(localStorage.getItem("user") || "{}"),
    [],
  );
  const userId = user?.id;
  const [menuItems, setMenuItems] = useState<MenuItemProps[]>([]);

  const availableMenuItems = useMemo(
    () => [
      { to: "/", icon: "account", label: "Accounts", privilege: "view.users" },
      {
        to: "/transactions",
        icon: "transaction",
        label: "Transactions",
        privilege: "view.orders",
      },
      {
        to: "/balance-adjustments",
        icon: "balanceAdjustment",
        label: "Balance Adjustment",
        privilege: "view.admins",
      },
      {
        to: "/mediation",
        icon: "mediation",
        label: "Mediation",
        privilege: "view.mediation.requests",
      },
      {
        to: "/blacklist",
        icon: "blacklist",
        label: "Blacklist",
        privilege: "view.blacklist",
      },
      {
        to: "/support",
        icon: "support",
        label: "Customer Support",
        privilege: "view.analytics",
      },
      {
        to: "/analytics",
        icon: "analytics",
        label: "Analytics",
        privilege: "view.users",
      },
      {
        to: "/referral-program",
        icon: "referralProgram",
        label: "Referral Program",
        privilege: "",
      },
      {
        to: "/campaign",
        icon: "campaign",
        label: "Campaign",
        privilege: "",
      },
      {
        to: "/admins",
        icon: "account",
        label: "Admins",
        privilege: "view.admins",
      },
      {
        to: "/roles",
        icon: "account",
        label: "Roles and Privileges",
        privilege: "create.roles",
      },
      {
        to: "/email-management",
        icon: "emailManagement",
        label: "Email Management",
        privilege: "",
      },
      {
        to: "/fee-management",
        icon: "feeManagement",
        label: "Fee Management",
        privilege: "",
      },
      {
        to: `/admins/profile-detail/${userId}`,
        icon: "myProfile",
        label: "My Profile",
        privilege: "",
      },
      { to: "/settings", icon: "settings", label: "Settings", privilege: "" },
    ],
    [userId],
  );

  useEffect(() => {
    const userPrivileges = user?.role?.privileges || [];

    const filteredMenuItems = availableMenuItems.filter(
      (item) =>
        item.privilege === "" ||
        userPrivileges.some((p: any) => p.name === item.privilege),
    );

    setMenuItems(filteredMenuItems);
  }, [user, availableMenuItems]);

  return (
    <>
      {menuItems.map((item, index) => (
        <MenuItem
          key={index}
          to={item.to}
          label={item.label}
          icon={item.icon}
        />
      ))}
    </>
  );
};

export default Menu;
